import { render, staticRenderFns } from "./JMAInfo.vue?vue&type=template&id=6507d572&scoped=true"
import script from "./JMAInfo.vue?vue&type=script&lang=js"
export * from "./JMAInfo.vue?vue&type=script&lang=js"
import style0 from "./JMAInfo.vue?vue&type=style&index=0&id=6507d572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6507d572",
  null
  
)

export default component.exports